module.exports = __webpack_public_path__ + "static/media/alien1.3a28dfaf.gif";